const production = {
  sui_network: 'mainnet',
  api_url: 'https://api.parrot.finance/pre',
  explorer_url: {
    suivision: {
      txb: 'https://suivision.xyz/txblock/{{txb}}',
      account: 'https://suivision.xyz/account/{{account}}',
      object: 'https://suivision.xyz/object/{{object}}',
      coin: 'https://suivision.xyz/coin/{{coin}}',
    },
    suiscan: {
      txb: 'https://suiscan.xyz/mainnet/tx/{{txb}}',
      account: 'https://suiscan.xyz/mainnet/account/{{account}}',
      object: 'https://suiscan.xyz/mainnet/object/{{object}}',
      coin: 'https://suiscan.xyz/mainnet/coin/{{coin}}',
    },
  },
  rpc: <Record<string, string>>{
    suiscan: 'https://rpc-mainnet.suiscan.xyz/',
    sui_Official: 'https://fullnode.mainnet.sui.io:443',
    suiet: ' https://mainnet.suiet.app/',
    shinami: 'https://api.shinami.com/node/v1/sui_mainnet_bb70bc6a7d6d04694c4c719f0b6f27aa',
  },
  fullnode: 'https://fullnode.mainnet.sui.io:443',
  pyth_endpoint: 'https://hermes.pyth.network',
  vaultsManager: '0x231b803d8106817c1e601ed34d5b101670fcb543a689c9356cf11185b1572276',
  rewarderManager: '0xcf62753661690f7853688941ba02baf56aa1ad876b7710b1c3d5e5f8c9ab4de3',
  // burn_package_id: '0x89253eb9ca5bf424a118bfc1a172bbc2dd39d38becd00e5cbf24b87ee828bce5',
  // fun: {
  //   originPackageId: '0x96e1396c8a771c8ae404b86328dc27e7b66af39847a31926980c96dbc1096a15',
  //   packageId: '0x96e1396c8a771c8ae404b86328dc27e7b66af39847a31926980c96dbc1096a15',
  //   globalConfig: '0xd86685fc3c3d989385b9311ef55bfc01653105670209ac4276ebb6c83d7df928',
  //   configuration: '',
  //   bytecodeBase64:
  //     'oRzrCwYAAAAKAQAMAgweAyonBFEIBVlXB7ABzAEI/AJgBtwDKwqHBAUMjAQsABABCwIGAhECEgITAAICAAEBBwEAAAIADAEAAQIDDAEAAQQEAgAFBQcAAAkAAQABDwUGAQACBwgJAQIDDAUBAQwDDQ4BAQwEDgsMAAUKAwQAAQQCBwMKBA0CCAAHCAQAAgsCAQgACwMBCAABCgIBCAUBCQABCwEBCQABCAAHCQACCgIKAgoCCwEBCAUHCAQCCwMBCQALAgEJAAELAgEIAAEGCAQBBQELAwEIAAIJAAUMQ29pbk1ldGFkYXRhBk9wdGlvbghURU1QTEFURQtUcmVhc3VyeUNhcAlUeENvbnRleHQDVXJsBGNvaW4PY3JlYXRlX2N1cnJlbmN5C2R1bW15X2ZpZWxkBGluaXQVbmV3X3Vuc2FmZV9mcm9tX2J5dGVzBm9wdGlvbhRwdWJsaWNfZnJlZXplX29iamVjdA9wdWJsaWNfdHJhbnNmZXIGc2VuZGVyBHNvbWUIdGVtcGxhdGUIdHJhbnNmZXIKdHhfY29udGV4dAN1cmwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICAQYKAgcGU1lNQk9MCgIFBE5BTUUKAgwLREVTQ1JJUFRJT04KAgQDVVJMAAIBCAEAAAAAAhQLAAcABwEHAgcDBwQRBjgACgE4AQwCDAMLAjgCCwMLAS4RBTgDAgA=',
  // },
};

export type Config = typeof production;

export default production;
